import React from 'react';

import GenericReadonlyCell from '@atlassian/jira-portfolio-3-portfolio/src/app-export-view/view/component-slot-content/generic-readonly-cell';
import type { Props } from './types';

const ReadonlyCellTextfield = ({ value, isAlignRight }: Props) => (
	<GenericReadonlyCell align={isAlignRight === true ? 'right' : 'left'} text={value} />
);

export default ReadonlyCellTextfield;
